export const CommentIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="inherit">
        <g opacity="0.6" clip-path="url(#clip0_2059_4099)">
            <path d="M7.69098 0.462422C5.66448 0.325339 3.68057 1.06676 2.24965 2.49942C0.818732 3.93209 0.0802324 5.91601 0.220816 7.94367C0.477482 11.6502 3.75115 14.4455 7.83565 14.4455H11.2872C12.8955 14.4455 14.2039 13.1371 14.2039 11.5288V7.64384C14.2033 3.86501 11.3427 0.710339 7.69098 0.462422ZM4.28665 8.32051C3.80365 8.32051 3.41165 7.92851 3.41165 7.44551C3.41165 6.96251 3.80365 6.57051 4.28665 6.57051C4.76965 6.57051 5.16165 6.96251 5.16165 7.44551C5.16165 7.92851 4.76965 8.32051 4.28665 8.32051ZM7.20332 8.32051C6.72032 8.32051 6.32832 7.92851 6.32832 7.44551C6.32832 6.96251 6.72032 6.57051 7.20332 6.57051C7.68632 6.57051 8.07832 6.96251 8.07832 7.44551C8.07832 7.92851 7.68632 8.32051 7.20332 8.32051ZM10.12 8.32051C9.63698 8.32051 9.24498 7.92851 9.24498 7.44551C9.24498 6.96251 9.63698 6.57051 10.12 6.57051C10.603 6.57051 10.995 6.96251 10.995 7.44551C10.995 7.92851 10.603 8.32051 10.12 8.32051Z" fill="inherit"/>
        </g>
        <defs>
            <clipPath id="clip0_2059_4099">
            <rect width="14" height="14" fill="white" transform="translate(0.203125 0.445312)"/>
            </clipPath>
        </defs>
        </svg>
    `,
      }}
    />
  );
};
